import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {IMyOptions} from "mydatepicker";

@Component({
    selector: 'app-company-visa-add',
    templateUrl: './company-visa-add.component.html',
})
export class CompanyVisaAddComponent implements OnInit {
    node = 'company-visa';
    usersNode = 'user';
    visaStatusNode = 'visa-status';

    users = [{}];
    //company = {};

    visaStatuses = [{}];

    myDatePickerOptions: IMyOptions = {
        // other options...
        // dateFormat: 'dd/mm/yyyy',
        dateFormat: 'yyyy-mm-dd',
    };
    text: string;

    results: [{}];

    constructor(
        private apiService: ApiService,
        private dataService: DataService,
        private location: Location,
    ) {
    }

    ngOnInit() {
        this.dataService.refresh();
        this.getUsers();
        this.getVisaStatuses();
    }


    getUsers() {
        this.apiService.getAll(this.usersNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.users = [{}];
                } else {
                    this.users = response.json().data;
                }
            })
    }

    getVisaStatuses() {
        this.apiService.getAll(this.visaStatusNode)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.visaStatuses = [{}];
                    } else {
                        this.visaStatuses = response.json().data;
                        console.log(this.visaStatuses);
                    }
                },
                (error) => {this.visaStatuses = [{}];}
            );
    }



    onFormSubmit(formData) {
        var data = {
            company_id: formData.value.companyObject.company_id,
            permit_issue_date: (formData.value.permit_issue_date.formatted)?formData.value.permit_issue_date.formatted:'',
            permit_expiry_date: (formData.value.permit_expiry_date.formatted)?formData.value.permit_expiry_date.formatted:'',
            visa_issue_date: (formData.value.visa_issue_date.formatted)?formData.value.visa_issue_date.formatted:'',
            visa_expiry_date: (formData.value.visa_expiry_date.formatted)?formData.value.visa_expiry_date.formatted:'',
            arrival_date: (formData.value.arrival_date.formatted)?formData.value.arrival_date.formatted:'',
            visa_status_id: formData.value.visa_status_id
        };
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: ' + response.json().message);
                    } else {
                        alert('Success: ' + response.json().message);
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }


    search(event) {
        this.apiService.getUsingQuery('company', 'search=' + event.query + '&search_field=company_name')
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.results = [{}]
                } else {
                    this.results = response.json().data;
                }
            })
    }


    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-visa/company-visa-add.component.ts